import { render, staticRenderFns } from "./historic-task-detail.vue?vue&type=template&id=12e5421c&scoped=true&"
import script from "./historic-task-detail.vue?vue&type=script&lang=js&"
export * from "./historic-task-detail.vue?vue&type=script&lang=js&"
import style0 from "./historic-task-detail.vue?vue&type=style&index=0&id=12e5421c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12e5421c",
  null
  
)

export default component.exports